/**
 * @description 生成随机数
 */
export const randomNum = (length: number) => {
  let num = '';
  for (let i = 0; i < length; i++) {
    num += Math.floor(Math.random() * 9 + 1);
  }
  console.log(num);
};
